<div
  class="transaction-details-container"
  *ngIf="combinedFilingData$ | async as combinedFilingData"
>
  <fsx-transaction-details
    [combinedFilingData]="combinedFilingData"
  ></fsx-transaction-details>
</div>
